<template>
  <div class="field-messages pr-2">
    <!-- API-sourced errors -->
    <template v-if="fieldData.error
    && fieldData.error !== 'Required.'
    && fieldData.has_error">
      <div class="form-row mx-0">
        <div class="text-danger px-2 mt-1 aaa">
          {{ fieldData.error }}
        </div>
      </div>
    </template>
    <!-- Frontend-sourced errors -->
    <template v-else-if="errors.has(fieldData.field_name)
    && errors.first(fieldData.field_name) !== 'Required.'">
      <div class="form-row mx-0">
        <div v-show="errors.has(fieldData.field_name)" class="text-danger px-2 mt-1 bbb">
          <i class="fas fa-exclamation-triangle" title="Required field icon"></i>
          {{ errors.first(fieldData.field_name) }}
        </div>
      </div>
    </template>
    <!-- "Required." error messages only -->
    <template v-else-if="errors.has(fieldData.field_name)
      || fieldData.has_error
      && (errors.first(fieldData.field_name) === 'Required.' || fieldData.error === 'Required.')">
      <div class="form-row mx-0 required-error-block">
        <div class="text-danger px-2 mt-1 required-error ccc">
          <i class="fas fa-exclamation-triangle" title="Required Field"></i>
          Required.
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: [
    'fieldData',
    'yesreq', // Boolean to distinguish whether the message(s) is of the "required" type, which have a different style
  ],
};
</script>

<style scoped>
  .required-error-block {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldMessages.vue?5b700720